import PhotoListHorizontal from './photo_list_horizontal';

export default PhotoListHorizontal;
